// src/components/modals/ProfileSettingsModal.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@mui/material';

function ProfileSettingsModal({ open, onClose, user }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Profile Information</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="First Name"
            fullWidth
            variant="outlined"
            value={user.first_name}
            InputProps={{ readOnly: true }}
          />
          <TextField
            label="Last Name"
            fullWidth
            variant="outlined"
            value={user.last_name}
            InputProps={{ readOnly: true }}
          />
          <TextField
            label="Email"
            fullWidth
            variant="outlined"
            value={user.email}
            InputProps={{ readOnly: true }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProfileSettingsModal;
